import { useCallback, useState } from "react";

import { Button, Text } from "@fluentui/react-components";
import { CheckmarkCircleFilled, CircleFilled, OpenFilled } from "@fluentui/react-icons";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { darkModeAtom, selectedFullThemeAtom } from "store";
import styled from "styled-components";
import { darkStyledTheme, styledTheme } from "theme";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";

import { generateTheme } from "./GrecoPanel/Settings/ThemeSelector/themeGenerator";
import { ThemeDialog } from "./SettingsMenu/ThemeSettings/ThemeDialog";

export function ThemeSettings() {
  const theme = useAppTheme();
  const { t } = useTranslation();
  const darkMode = useAtomValue(darkModeAtom);
  const [themeDialog, setThemeDialog] = useState(false);

  const mainTheme = darkMode ? darkStyledTheme : styledTheme;

  const mainColor = mainTheme.palette.purpleDark;

  const setSelectedFullTheme = useSetAtom(selectedFullThemeAtom);

  const handleChangePrimaryColor = (color) => {
    const { lightTheme, darkTheme } = generateTheme(color);

    setSelectedFullTheme({
      light: lightTheme,
      dark: darkTheme,
    });
  };

  const onCloseThemeDialog = useCallback(() => {
    setThemeDialog(false);
  }, []);

  const themePalette = ["#156aac", "#CA5010", "#986F0B", "#2e5c59", "#a4262c", "#00bcf2"];
  return (
    <>
      <Flex direction="column" align="flex-start" $gap={"15px"}>
        <Text>{t("hbh.theme.label")}</Text>
        <Flex $gap={"4px"}>
          <StyledButton
            appearance="transparent"
            onClick={() => {
              setSelectedFullTheme({
                light: styledTheme,
                dark: darkStyledTheme,
              });
            }}
            icon={
              mainColor === theme.palette.purpleDark ? (
                <CheckmarkCircleFilled
                  style={{
                    color: mainTheme.palette.purpleDark,
                  }}
                />
              ) : (
                <CircleFilled
                  style={{
                    color: mainTheme.palette.purpleDark,
                  }}
                />
              )
            }
          />
          {themePalette.map((color) => (
            <StyledButton
              appearance="transparent"
              onClick={() => {
                if (color !== theme.palette.purpleDark) {
                  handleChangePrimaryColor(color);
                }
              }}
              icon={
                color === theme.palette.purpleDark ? (
                  <CheckmarkCircleFilled
                    style={{
                      color: color,
                    }}
                  />
                ) : (
                  <CircleFilled
                    style={{
                      color: color,
                    }}
                  />
                )
              }
            />
          ))}
          <StyledButton
            onClick={() => {
              setThemeDialog(true);
            }}
            appearance="transparent"
            icon={<OpenFilled />}
          />
        </Flex>
      </Flex>
      <ThemeDialog open={themeDialog} onClose={onCloseThemeDialog} />
    </>
  );
}

const StyledButton = styled(Button)`
  padding: 0px !important;
  margin: 0px !important;
  min-width: fit-content !important;
`;
